import React from 'react';
import { Avatar } from '@barges/react';
import { SvgIcon } from '@common/sprites';
import classes from './classes.module.scss';
import { getTimeOnBubble } from '../../config/util';

interface ChatBubbleProps {
  id: string;
  message: string;
  isUser: boolean;
  holisticServiceName?: string;
  isTyping: boolean;
  avatarSrc?: string | null;
  time: string;
  holisticServiceTitle: string;
  onHolisticServiceClick?: () => void;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({
  id, message, isUser, holisticServiceName, isTyping, avatarSrc = null, time, onHolisticServiceClick, holisticServiceTitle
}) => {
  const timeOnBubble = getTimeOnBubble({ time });

  const renderHolisticServiceBubble = () => {
    if (!holisticServiceName || !onHolisticServiceClick) return null;

    return (
      <div
        className={ classes.holisticServiceBubbleContainer }
        onClick={ onHolisticServiceClick }
        onKeyDown={ (e) => {
          if (e.key === 'Enter' || e.key === ' ') onHolisticServiceClick();
        } }
        role="button"
        tabIndex={ 0 }
      >
        <div className={ classes.holisticServiceTextContainer }>
          <div className={ classes.holisticServiceTitle }>{holisticServiceTitle}</div>
          <div className={ classes.holisticServiceName }>{holisticServiceName}</div>
        </div>
        <div className={ classes.holisticServiceArrowContainer }>
          <SvgIcon id="right_arrow" size={ 24 } />
        </div>
      </div>
    );
  };

  const renderMessageContent = () => {
    if (isTyping) {
      return (
        <div className={ classes.chatBubbleLoader }>
          <div className={ classes.chatBubbleLoaderCircle } />
          <div className={ classes.chatBubbleLoaderCircle } />
          <div className={ classes.chatBubbleLoaderCircle } />
        </div>
      );
    }

    return (
      <div className={ classes.chatBubbleMessage }>
        {renderHolisticServiceBubble()}
        <div className={ classes.chatBubbleMessageText }>
          {message?.split('\n')?.map((item, index) => (
            <div key={ index }>{item}</div>
          ))}
          <div className={ classes.chatBubbleTime }>
            <div className={ classes.chatBubbleMessageTimeText }>{timeOnBubble}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div id={ id } className={ classes.chatBubbleWrapper } style={ isUser ? { alignSelf: 'flex-end' } : { alignSelf: 'flex-start' } }>
      {!isUser && (
        <div className={ classes.chatBubbleAvatarContainer }>
          <Avatar
            imgSrc={ avatarSrc }
          />
        </div>
      )}
      <div className={ isUser ? classes.chatBubbleUser : classes.chatBubbleOther }>
        {renderMessageContent()}
      </div>
    </div>
  );
};
export default ChatBubble;
